import { HTMLProps } from 'react';

import { Theme, WithStyles, createStyles, withStyles } from '@material-ui/core';

import classNames from 'classnames';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flex: 1,
      [theme.breakpoints.up('md')]: {
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
      },
    },
  });

export interface AppHeaderSearchProps
  extends HTMLProps<HTMLDivElement>,
    WithStyles<typeof styles> {}

const AppHeaderSearch = (props: AppHeaderSearchProps) => {
  const { className, classes, ...rest } = props;
  return <div className={classNames(classes.root, className)} {...rest} />;
};

export default withStyles(styles)(AppHeaderSearch);
